import { Toaster } from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

import DrawerComponent from 'atoms/drawer';
import getRoutes from 'config/routes';
import useWindowDimensions from 'hooks/useWindowDimensions';
import AdminNavbar from 'organisms/AdminNavbar';
import AppointmentActionsModal from 'organisms/Appointments/AppointmentActions/AppointmentActionsModal';
import LateCancelModal from 'organisms/Appointments/AppointmentActions/LateCancelModal';
import NoShowModal from 'organisms/Appointments/AppointmentActions/NoShowModal';
import NotifyClientModal from 'organisms/Appointments/AppointmentActions/NotifyClientModal';
import AppointmentCompletedModal from 'organisms/DrawerContent/Payment/AppointmentCompletedModal';
import { MobileNavbar } from 'organisms/MobileNavbar';
import Navbar from 'organisms/Navbar';
import ScrollToTop from 'organisms/ScrollToTop';

dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);

function AppContainer() {
  const location = useLocation();
  const { isAdmin } = useSelector((state) => state.user);
  const {
    appointmentActionsModal,
    checkoutSuccessModal,
    appointmentNoShowModal,
    appointmentLateCancelModal,
    appointmentNotifyClientModal,
  } = useSelector((state) => state.ui);
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const hideUrls = [
    'signup',
    'consumer',
    'login',
    'password',
    'privacy',
    'add-service',
    'add-service-optional',
  ];

  const hideNavbar =
    hideUrls.some((el) => location.pathname.includes(el)) ||
    location.pathname === '/';

  return (
    <>
      <ScrollToTop />
      <div id="app">
        <div className="app-wrapper">
          <div
            className={classNames(
              'app-wrapper-container',
              hideNavbar ? 'home-navbar' : 'app-navbar'
            )}
          >
            <Toaster
              toastOptions={{
                className: 'toast',
                duration: 5000,
                position: 'bottom-center',
              }}
            />
            <DrawerComponent />
            {!hideNavbar && !isMobile && <Navbar isAdmin={isAdmin} />}
            {!hideNavbar && isMobile && <MobileNavbar />}
            {appointmentActionsModal.isOpen && <AppointmentActionsModal />}
            {checkoutSuccessModal.isOpen && <AppointmentCompletedModal />}
            {appointmentNoShowModal.isOpen && <NoShowModal />}
            {appointmentLateCancelModal.isOpen && <LateCancelModal />}
            {appointmentNotifyClientModal.isOpen && <NotifyClientModal />}
            <div className="w-100 flex-column app-wrapper-body">
              <AdminNavbar />
              {getRoutes()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AppContainer;
